import { useCallback, useMemo } from 'react';
import { useAppContext } from 'src/context/store/app-provider';
import {
  type GlobalAnalyticsProperties,
  type SegmentEvent,
} from 'src/types/segment';
import { dataDog } from 'src/utils/datadog/data-dog';
import { findExperiment } from 'src/utils/find-experiment';
import { getDeviceType } from 'src/utils/get-device-type';
import { getSourcePlugin } from 'src/utils/get-source-plugin';
import { sendSegmentEvent } from 'src/utils/send-segment-event';

export const useAnalytics = () => {
  const { merchantCode, aid, entityId, experiments } = useAppContext();
  const ltfKsaSnippetExpValue = findExperiment(
    'BNPL-11864-KSA-LTF-snippet',
    experiments
  );

  const globalProps: GlobalAnalyticsProperties = useMemo(
    () => ({
      merchantCode,
      platformType: getDeviceType(),
      productType: 'installments',
      merchantId: aid,
      sourcePlugin: getSourcePlugin(),
      ltfKsaSnippetExpValue,
    }),
    [merchantCode, aid, ltfKsaSnippetExpValue]
  );

  return useCallback(
    ({ event, ...restProperties }: SegmentEvent) => {
      const analyticProperties = { ...globalProps, ...restProperties };

      sendSegmentEvent(event, entityId, analyticProperties);

      dataDog.info('segment', event, analyticProperties); // logs all analytics events to DD
    },
    [globalProps, entityId]
  );
};
